import React from 'react';
import { Input, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useSectionActionPlan } from '../context';
import { Label, FormWrapper } from '../components';

export function Description() {
	const { form_field_name } = useSectionActionPlan();
	return (
		<Row>
			<Label>{I18n.get('Description')}</Label>
			<FormWrapper name={[...form_field_name, 'description']}>
				<Input.TextArea
					rows={5}
					showCount
					maxLength={500}
					placeholder={I18n.get(
						'Describe the situation detected and the preventive measures already implemented (if any)'
					)}
				/>
			</FormWrapper>
		</Row>
	);
}
